import './image-slider.scss';
import 'slick-carousel';

export default () => {
	$( '.js-image-slider' ).slick( {
		dots: true,
		arrows: true,
		infinite: true,
		autoplay: false,
		speed: 300,
		swipe: true,
		rows: 0,
		variableWidth: true,
		appendArrows: '.image-slider__slider-arrows',
		appendDots: '.image-slider__slider-arrows',
		nextArrow:
      '<button class=\'slick-next\'><i class=\'icon-arrow-next\'></i></button>',
		prevArrow:
      '<button class=\'slick-prev\'><i class=\'icon-arrow-prev\'></i></button>',
	} );
};
